<div class="app-table-container">
    <table class="app-table">
        <thead class="app-table-head">
            <tr class="app-table-head-row">
                <th *ngFor="let column of columns">{{column.name}}</th>
            </tr>
        </thead>

        <tbody class="app-table-body">
            <tr *ngFor="let item of data; let i = index"
                class="app-table-body-row">
                <td *ngFor="let column of columnsToDisplay"
                    [innerHtml]="item ? column.cell(item) : ''">
                </td>
                <td *ngIf="!removeButton" class="d-flex">
                    <app-tooltip text="Editar" position="top"
                        *ngIf="canEditRow(item)">
                        <button class="app-table-remove"
                            (click)="onEditClicked(i)">
                            <svg-icon
                                src="assets/images/icon-edit.svg"></svg-icon>
                        </button>
                    </app-tooltip>
                    <!-- Espaço invisível para manter alinhamento quando não há botão de editar -->
                    <div *ngIf="!canEditRow(item)"
                        style="width: 32px; height: 32px;"></div>
                    <app-spacer [right]="8"
                        *ngIf="canEditRow(item)"></app-spacer>
                    <app-tooltip text="Excluir" position="top">
                        <button class="app-table-remove"
                            (click)="onRemoveClicked(i)">
                            <svg-icon
                                src="assets/images/icon-trash.svg"></svg-icon>
                        </button>
                    </app-tooltip>
                </td>
            </tr>
            <tr *ngIf="data.length === 0" class="app-table-footer-row">
                <td [attr.colspan]="columnsToDisplay.length">Nenhum dado
                    adicionado</td>
            </tr>
        </tbody>

        <tfoot *ngIf="footerData.length > 0" class="app-table-footer">
            <tr *ngFor="let item of footerData" class="app-table-footer-row">
                <td *ngFor="let column of footerColumnsToDisplay"
                    [innerHtml]="column.cell(item)"></td>
            </tr>
        </tfoot>
    </table>
</div>